import { Column, Row, Section, Text } from "@react-email/components";
import { EmailComponentWrapper } from "../../utils/email-component-wrapper";
import useThemeContextualColors, { sectionToParent } from "../../hooks/use-theme-contextual-colors";
import { tLayout } from "../../translations";
import type { CrossSellBlockProps } from "./types";

const grey = "#e5e7eb";

function PlaceholderItem() {
  return (
    <div style={{ display: "flex", flexDirection: "column", gap: "6px" }}>
      <div
        style={{
          width: "100%",
          aspectRatio: "16 / 9",
          backgroundColor: grey,
          borderRadius: "8px",
        }}
      />
      <div style={{ height: "12px", width: "70%", backgroundColor: grey, borderRadius: "4px" }} />
      <div style={{ height: "12px", width: "40%", backgroundColor: grey, borderRadius: "4px" }} />
    </div>
  );
}

export function CrossSellEditorRenderer({ block, shop, locale, defaultLocale, theme, section }: CrossSellBlockProps) {
  const count = block?.properties?.count ?? 2;
  const t = tLayout(locale, defaultLocale);
  const colors = useThemeContextualColors(theme, sectionToParent(section));

  return (
    <EmailComponentWrapper shop={shop}>
      <Section>
        <Row>
          <Column style={{ padding: "4px 4px 8px" }}>
            <Text className="m-0 p-0 leading-[1.4] font-semibold" style={{ color: colors.text }}>
              {t("crossSell.youMightAlsoLike")}
            </Text>
          </Column>
        </Row>

        {count === 1 && (
          <Row>
            <Column style={{ width: "100%", padding: "4px" }}>
              <div style={{ maxWidth: "280px" }}>
                <PlaceholderItem />
              </div>
            </Column>
          </Row>
        )}

        {count === 2 && (
          <Row>
            {([0, 1] as const).map((i) => (
              <Column key={i} style={{ width: "50%", verticalAlign: "top", padding: "4px" }}>
                <PlaceholderItem />
              </Column>
            ))}
          </Row>
        )}

        {count === 3 && (
          <Row>
            <Column style={{ width: "50%", verticalAlign: "top", padding: "4px" }}>
              <PlaceholderItem />
              <div style={{ height: "8px" }} />
              <PlaceholderItem />
            </Column>
            {/* height: "1px" on the td makes height: "100%" work on the inner div */}
            <Column style={{ width: "50%", verticalAlign: "top", padding: "4px", height: "1px" }}>
              <div style={{ display: "flex", flexDirection: "column", height: "100%", gap: "6px" }}>
                <div style={{ flex: 1, backgroundColor: grey, borderRadius: "8px" }} />
                <div style={{ height: "12px", width: "70%", backgroundColor: grey, borderRadius: "4px" }} />
                <div style={{ height: "12px", width: "40%", backgroundColor: grey, borderRadius: "4px" }} />
              </div>
            </Column>
          </Row>
        )}

        {count === 4 && (
          <>
            <Row>
              {([0, 1] as const).map((i) => (
                <Column key={i} style={{ width: "50%", verticalAlign: "top", padding: "4px" }}>
                  <PlaceholderItem />
                </Column>
              ))}
            </Row>
            <Row>
              {([0, 1] as const).map((i) => (
                <Column key={i} style={{ width: "50%", verticalAlign: "top", padding: "4px" }}>
                  <PlaceholderItem />
                </Column>
              ))}
            </Row>
          </>
        )}
      </Section>
    </EmailComponentWrapper>
  );
}
